import { render, staticRenderFns } from "./novice.vue?vue&type=template&id=341bd6cb&scoped=true&"
import script from "./novice.vue?vue&type=script&lang=js&"
export * from "./novice.vue?vue&type=script&lang=js&"
import style0 from "./novice.vue?vue&type=style&index=0&id=341bd6cb&prod&lang=css&"
import style1 from "./novice.vue?vue&type=style&index=1&id=341bd6cb&prod&lang=less&scoped=true&"
import style2 from "./novice.vue?vue&type=style&index=2&id=341bd6cb&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341bd6cb",
  null
  
)

export default component.exports